import React from "react";

const VistaFeatures = () => {
  return (
    <>
      <div className="md:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <div className="col-span-1 mb-6 md:mb-0 row-span-1 lg:h-[280px] bg-[#3b82f6] rounded-3xl">
          <div className="p-6">
            <img
              alt="Smart Connectivity"
              src="https://content.qeeb.in/coltec/products/commercial-display/listing/smart-connectivity.webp"
              className="h-[135px] flex justify-center mx-auto"
            />
            <h2 className="text-white text-lg font-semibold mb-2">
              Smart Connectivity
            </h2>
            <p className="text-white text-xs font-medium">
              Effortlessly integrate displays into your ecosystem with versatile
              connectivity for seamless content sharing and remote management.
            </p>
          </div>
        </div>
        <div className="col-span-1 row-span-1 mb-6 md:mb-0 lg:h-[330px] bg-[#3b82f6] rounded-3xl">
          <div>
            <div className="px-6 pt-6">
              <h2 className="text-white text-lg font-semibold mb-3">
                24x7 Operation
              </h2>
              <p className="text-white text-xs font-medium">
                COLTEC Vista displays are engineered for continuous, dependable
                performance—delivering uninterrupted visuals day and night, even
                in the most demanding environments.
              </p>
            </div>
            <div className="flex justify-center">
              <img
                alt="24x7 Operation"
                src="https://content.qeeb.in/coltec/products/commercial-display/listing/24x7-operation.webp"
                className="h-[140px] object-contain"
              />
            </div>
          </div>
        </div>
        <div className="col-span-1 row-span-1 mb-6 md:mb-0 lg:h-[330px] bg-white rounded-3xl border-4 border-[#3b82f6]">
          <div className="p-6">
            <img
              alt="Energy Efficient"
              src="https://content.qeeb.in/coltec/products/commercial-display/listing/energy-efficient.webp"
              className="mb-3 h-[160px] flex justify-center mx-auto"
            />
            <h2 className="text-[#4282ff] text-lg font-semibold mb-3">
              Energy Efficient
            </h2>
            <p className="text-black text-xs font-medium">
              COLTEC Vista displays combine outstanding performance with minimal
              power usage, reducing energy costs while delivering brilliant
              visuals around the clock.
            </p>
          </div>
        </div>
        <div className="col-span-1 row-span-1 mb-6 md:mb-0 lg:h-[300px] xl:mt-[-55px] bg-white rounded-3xl border-4 border-[#3b82f6]">
          <div className="p-6">
            <img
              alt="True Color Accuracy"
              src="https://content.qeeb.in/coltec/products/commercial-display/listing/true-color-accuracy.webp"
              className="h-[140px] flex justify-center mx-auto mb-3"
            />
            <h2 className="text-[#4282ff] text-lg font-semibold mb-1">
              True Color Accuracy
            </h2>
            <div className="text-black text-xs font-medium">
              COLTEC Vista display reproduce colors precisely as intended,
              ensuring vibrant, lifelike visuals for presentations, media, and
              creative work.
            </div>
          </div>
        </div>
        <div className="col-span-2 row-span-1 bg-[#3b82f6] rounded-3xl">
          <div className="p-6">
            <div className="flex justify-start lg:space-x-5 md:flex-nowrap flex-wrap">
              <img
                alt="Cloud-Based Remote Management"
                src="https://content.qeeb.in/coltec/products/commercial-display/listing/cloud-based-remote-management.webp"
                className="h-[190px]"
              />
              <div className="mt-3 lg:mt-0">
                <h2 className="text-white text-lg font-semibold ">
                  Cloud-Based Remote Management
                </h2>
                <p className="text-white text-xs font-medium">
                  Effortlessly control, update, and monitor your entire display
                  network from anywhere, simplifying maintenance and ensuring
                  consistent, up-to-date content across all screens.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default VistaFeatures;
